import * as gridStyles from "@faire/retailer-visitor-shared/components/SDUI/ComponentRenderers/Grid/__internal__/styles.css";
import React from "react";

export const ProductTileRowPlaceholder: React.FC<{
  placeholderStyles?: React.CSSProperties;
}> = ({ placeholderStyles }) => {
  return (
    <div
      className={gridStyles.productTileRowPlaceholder}
      style={placeholderStyles}
      data-test-id="product-tile-row-placeholder"
    />
  );
};

export const BrandTileRowPlaceholder: React.FC<{
  placeholderStyles?: React.CSSProperties;
}> = ({ placeholderStyles }) => {
  return (
    <div
      className={gridStyles.brandTileRowPlaceholder}
      style={placeholderStyles}
    />
  );
};
